import React from 'react';
import PauseIcon from '@mui/icons-material/Pause';
import PlayArrowIcon from '@mui/icons-material/PlayArrow';
import './PausePlayButton.css'; // Assuming similar styling to ClearButton

const PausePlayButton = ({ isPaused, onToggle }) => {
  return (
    <button className="pause-play-button" onClick={onToggle}>
      {isPaused ? <PlayArrowIcon/> : <PauseIcon />}
    </button>
  );
};

export default PausePlayButton; 